import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../components/sidebar";
import { BASE_URL } from "../../utils/config";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DownloadIcon from "@mui/icons-material/Download";
import Stack from "@mui/material/Stack";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Loading from '../../components/loading';
import Container from 'react-bootstrap/Container';
import TelegramWidget from "../../components/widget/telegramWidget";

const Viewreport = () => {
  const navigate = useNavigate();
  const [loading,setLoading]=useState(true);
  const [loginuser, setLoginuser] = useState({});
  const [reportLists, setReportLists] = useState([]);
  const [reportList, setReportList] = useState([]);
  const [deleteRoleIDDialog, setDeleteRoleIDDialog] = useState(false);
  const [filters, setFilters] = useState();
  const [filteredUserLists, setfilteredUserLists] = useState();
  const [messageDialog,setMessageDialog]=useState(false)
  const [isSuccess,setIsSuccess]=useState(false)
  const [isFailed,setIsFailed]=useState(false)
  const [ApiError,setApiError]=useState(false)
  const dt = useRef(null);
  const toast = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [startIndex,setStartIndex]= useState(0);
  const [endIndex,setEndIndex]=useState(5);
    const [errorDialog, setErrorDialog] = useState(false);
    const [errorMsz, setErrorMsz] = useState("");

  const columns = [
    { 
      id: "S.No", 
      label: "S.No", 
      minWidth: 70, 
      align: "center" 
    },
    { 
      id: "report_name", 
      label: "Report Name", 
      minWidth: 150, 
      align: "center" 
    },
    {
      id: "action_type",
      label: "Action Type",
      minWidth: 120,
      align: "center",
    },
    {
      id: "stock_name",
      label: "Stock Name",
      minWidth: 170,
      align: "center",
    },
    {
      id: "User_Name",
      label: "Created By",
      minWidth: 170,
      align: "center",
    },
    {
      id: "created_at",
      label: "Created At",
      minWidth: 100,
      align: "left",
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 170,
      align: "center",
    },
  ];

  let count = 0;
  useEffect(() => {
    if(count === 0){
    fetchReportdata();
  count+= 1;  
  }}, []);


  //  this function is used to change  page
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let startindex  = newPage * rowsPerPage;
    console.log("startindex",startindex)
    let endindex =  Math.min(startindex + rowsPerPage, filteredUserLists.length)
    console.log("endindex",endindex)
    setStartIndex(startindex);
    setEndIndex(endindex)

  };

  //  this function is used to changes row in per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setEndIndex(+event.target.value);
    setStartIndex(0);
    setPage(0);
  };


  //  this function is used to fetch all created report list 
  const fetchReportdata = async () => {
    try{
    console.log("Fetching report list");
    let loginuser = JSON.parse(localStorage.getItem("loginData"));

     await fetch(
      `${BASE_URL}/getallreport/${loginuser.user_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${loginuser.token}`
        },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if(res.success === true){
          console.log("lenght of reocrd ",res.ReportData.length)
          setReportLists(res.ReportData);
          setfilteredUserLists(res.ReportData);
          setLoginuser(loginuser);
          setLoading(false)
        } else if(res.status === 403){ 
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else if(res.status === 401){
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }else{
          setApiError(true);
          setMessageDialog(true); 
          setLoading(false)
          setTimeout(() => {
           setMessageDialog(false); 
           setApiError(false);
         
         }, 1700);
        }
       
      }).catch((error)=>{
        setErrorMsz(`Error: ${error.message}`)
        setErrorDialog(true)
        setLoading(false)
        setTimeout(() => {
         setErrorDialog(false)
         setErrorMsz('')
        }, 2000);
      })
    }catch(error){

     setErrorMsz(`Error: ${error.message}`)
     setErrorDialog(true)
     setLoading(false)
     setTimeout(() => {
      setErrorDialog(false)
      setErrorMsz('')
     }, 2000);
    }
  };

  //  this function is used to show file name in simple
  const simplifyReportName = (reportName) => {
    switch (reportName) {
        case 'optionCall':
            return 'Call';
        case 'futureBuy':
            return 'Buy';
        case 'optionPut':
            return 'Put';
        case 'futureSell':
            return 'Sell';
        case 'delvieryReport':
            return 'Delivery';
        // Add more cases as needed
        default:
            return reportName;
    }
};

//  this function is used to show right toolbar
  const rightToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2 table-prehead-right">
       <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={exportCSV}
          >
            Export
          </Button>
        </Stack>
      </div>
    );
  };

  //  this function is used to show left toolbar
  const leftToolbarTemplate = () => {
    return (
      <>
        <span className="p-input-icon-left table-search">
          <i className="pi pi-search" />
          <InputText
            type="search"
            value={filters}
            onChange={handleSearch}
            placeholder="Search..."
          />
        </span>
      </>
    );
  };

  //  this function is used to search 
  const handleSearch = (event) => {
    let filetertext = event.target.value;
    setFilters(event.target.value);
    setPage(0);
    setfilteredUserLists(reportLists.filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === 'string' &&
          value.toLowerCase().includes(filetertext.toLowerCase())
      )))
  };

//  this function is used to export file
  const exportCSV = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(reportLists);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "User_List");
    });
  };

  //  this function is used to save file as excel in user system
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        const date = new Date();

        // Extract date components
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        // Extract time components
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");

        // Combine date and time components
        const dateTime = `${year}-${month}-${day}_${hours}:${minutes}:${seconds}`;

        module.default.saveAs(
          data,
          fileName + "_export_" + dateTime + EXCEL_EXTENSION
        );
      }
    });
  };

  //  this function is used to hide delete dialog box
  const hideDeleteProductDialog = () => {
    setDeleteRoleIDDialog(false);
  };

  //  this function is used to open a delete popup
  const confirmDeleteProduct = (reportlist) => {
    setReportList(reportlist);
    setDeleteRoleIDDialog(true);
  };

  //  this function is used to render action body template
  const actionBodyTemplate = (rowData) => {
    return (
        <div className="actions">
        <i
          className="pi pi-eye"
          style={{ color: "#23499E", cursor: "pointer" }}
          title="View"
          onClick={() => edituser(rowData)}
        ></i>      
          <i
            className="pi pi-trash"
            style={{ color: "#fa896b", cursor: "pointer" }}
            title="Delete"
            onClick={() => confirmDeleteProduct(rowData)}
          ></i>
      </div>
    );
  };

  // this function is used to delete report 
  const deleteProduct = async () => {
    try{
    let id   = reportList.id;
    let body = JSON.stringify({ created_by: loginuser.user_name });
     await fetch(`${BASE_URL}/softdelReport/${id}`, {
      method: "DELETE",
      body,
      headers: {
        "Content-Type": "application/json",
         'Authorization': `Bearer ${loginuser.token}`
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res.success === true) {
          let _products = reportLists.filter(
            (val) => val.id !== reportList.id

          );
          setReportLists(_products);
          setfilteredUserLists(_products);
          setDeleteRoleIDDialog(false);
          setReportList("");

          setIsSuccess(true);
          setMessageDialog(true);

          setTimeout(() => {
            setMessageDialog(false); 
            setIsSuccess(false);
          
          }, 1700);
          
        }
        else if(res.status === 403){ 
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else if(res.status === 401){
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        } else {
         

          setIsFailed(true);
          setMessageDialog(true);

          setTimeout(() => {
            setMessageDialog(false); 
            setIsFailed(false);
          
          }, 1700);
        }
      }).catch((error)=>{
      
        setErrorMsz(`Error: ${error.message}`)
        setErrorDialog(true)
        setTimeout(() => {
         setErrorDialog(false)
         setErrorMsz('')
        }, 2000);
      })

  }catch(error){
    setErrorMsz(`Error: ${error.message}`)
    setErrorDialog(true)
    setTimeout(() => {
     setErrorDialog(false)
     setErrorMsz('')
    }, 2000);
  }
};


//  this function is used to get report by id
  const edituser = async (reportlist) => {
    try{
    console.log("reportlist",reportlist);
    setReportList(reportlist);
    let reportdata = reportlist;
    await fetch(`${BASE_URL}/getreportbyid/${reportdata.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
         'Authorization': `Bearer ${loginuser.token}`
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res.success === true) {
          let Data = res.data
          navigate("/viewPdfReport", {
            state: { ReportDetails:Data.report , ReportFile: Data.fileContent },
          });
          // openNewTab(Data.report, Data.fileContent);
        }
        else if(res.status === 403){ 
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else if(res.status === 401){
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }else{
          setErrorMsz(`Error: ${res.message}`)
          setErrorDialog(true)
          setTimeout(() => {
           setErrorDialog(false)
           setErrorMsz('')
          }, 2000);
        }
      }).catch((error)=>{
        setErrorMsz(`Error: ${error.message}`)
        setErrorDialog(true)
        setTimeout(() => {
         setErrorDialog(false)
         setErrorMsz('')
        }, 2000);
      })
    }catch(error){
      setErrorMsz(`Error: ${error.message}`)
      setErrorDialog(true)
      setTimeout(() => {
       setErrorDialog(false)
       setErrorMsz('')
      }, 2000);
    }
  };



//   this function is used to format date

  const fromattedDate = (row)=>{
    const dateTimeString = row.created_at;

                  const parts = dateTimeString.split(".");

                  const date = new Date(parts[0]);

                  const istOffset = 330; // 5 hours * 60 minutes + 30 minutes

                  date.setMinutes(date.getMinutes() + istOffset);

                  const istDateTimeString = date.toLocaleString("en-IN", {
                    timeZone: "Asia/Kolkata",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "numeric",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                  });

                  const datePortion = istDateTimeString.split(",")[0];
                  const timePortion = istDateTimeString.split(",")[1];

                  return (
                    <div>
                      <div>Date: {datePortion}</div>
                      <div>Time: {timePortion}</div>
                    </div>
                  );

  }

  return (
    <div>
 
      <Sidebar />
      {loading?
      <div style={{position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 2,}}>
        <Loading/>
      </div>:
      <div className="add-user user-list">
        <Container>
          <h2>View Report</h2>
          <Toast ref={toast} />
          <Toolbar
            className="table-pre-head"
            start={leftToolbarTemplate}
            end={rightToolbarTemplate}
          ></Toolbar>
          <div className="table">
            


<Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead style={{backgroundColor:'#98C2EC'}}>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {filteredUserLists.length  > 0 ? (
                  <TableBody>
                    
                    {filteredUserLists
                      .slice(startIndex,endIndex)
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.id === "S.No"
                                    ? index + 1
                                    : column.id === "action_type"
                                    ? simplifyReportName(row.report_name)
                                    : column.id === "created_at"
                                    ? fromattedDate(row)
                                    : column.id === "Action"
                                    ? actionBodyTemplate(row)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>):null}                  
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredUserLists.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>

          <TelegramWidget/>

         

         {/*  delete report dialog  */}
          <Dialog
            open={deleteRoleIDDialog}
            onClose={hideDeleteProductDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Delete"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {reportList && (
                  <span style={{ color: "black" }}>
                    Are you sure ,you want to Delete Report{" "}
                    ?
                  </span>
                )}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                color="error"
                onClick={hideDeleteProductDialog}
              >
                No
              </Button>
              <Button
                variant="outlined"
                color="success"
                onClick={deleteProduct}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

          {/* error message dialog */}
          <Dialog
      open={messageDialog}
      onClose={()=>{setMessageDialog(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle  id="alert-dialog-title">
      
       {isSuccess?<h4 style={{ color: "green"}}>Success</h4>:null}
       {isFailed?<h4 style={{ color: "red" }}>Failure</h4>:null}
       {/* {ApiError ?<h4 style={{ color: "red" }}>Failure</h4>:null} */}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         
            
              {isSuccess ? 
               <span style={{ color: "black" }}>
                  Report Successfully Deleted.
                </span>
               : null}
                {isFailed?
                <span style={{ color: "black" }}>
                  Failed To Delete Report.
                </span>:null}

                {ApiError?
                <span style={{ color: "black" }}>
                   We're sorry, but something went wrong while processing your request.
                </span>:null}
              
           
        
        </DialogContentText>
      </DialogContent>
     
    </Dialog>
       
    {/* error dialog box */}
      <Dialog
          open={errorDialog}
          onClose={() => {
            setErrorDialog(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <div>
             
            
              <span style={{ color: "black" }}>
              {errorMsz}
              </span>
          
              
            </div>
            </DialogContentText>
          </DialogContent>
          </Dialog>
    
        </Container>
      </div>
      }
    </div>
  );
};

export default Viewreport;
